import {
    VIEWUSERDETAILS_SUCCESS,
    VIEWUSERDETAILS_FAILED,
    RESET_VIEWUSERDETAILS,
    LOADING_VIEWUSERDETAILS_,
    VIEWUSERDETAILS_NETWORKERROR,
} from "../types/index";

const initialState = {
    isLoading: false,
    success: false,
    network: false,
    failed: false,
    data: {}
};

export default (state = initialState, action) => {
    switch (action.type) {
        case LOADING_VIEWUSERDETAILS_:
            return {
                ...state,
                isLoading: true,
                success: false,
                failed: false,
                network: false,
                data: {}
            };
        case VIEWUSERDETAILS_FAILED:
            return {
                ...state,
                isLoading: false,
                success: false,
                failed: true,
                network: false,
                data: action.payload
            };
        case VIEWUSERDETAILS_SUCCESS:
            return {
                ...state,
                isLoading: false,
                success: true,
                failed: false,
                network: false,
                data: action.payload
            };
        case VIEWUSERDETAILS_NETWORKERROR:
            return {
                ...state,
                isLoading: false,
                success: false,
                failed: false,
                network: true,
                data: {}
            };
        case RESET_VIEWUSERDETAILS:
            return (state = initialState);
        default:
            return state;
    }
};
